<ng-container *ngIf="imageSrc">
    <img [src]="imageSrc" class="rounded-circle object-fit-cover image-container" [ngStyle]="getDimensions()" />
</ng-container>
<ng-container *ngIf="!imageSrc">
    <div class="d-flex align-items-center justify-content-center rounded-circle initials-image-container"
        [ngStyle]="getDimensions()">
        <span class="text-uppercase text-dark" [ngStyle]="getFontSize()">
            {{ getInitials() }}
        </span>
    </div>
</ng-container>